module.exports = __webpack_public_path__ + "static/media/get-recommendations-tablet-es.6e088dfe.webp";